import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { CustomerBillingPriceArticleModel, IBillingPriceListItemModel } from './customer-billing-price.model';

@Injectable()
export class CustomerBillingPriceService {
    constructor(private fiBackend: FiBackendService) {}

    GetBillingPrices() {
        return this.fiBackend.fetchDataPost<IBillingPriceListItemModel[]>(
            'CustomerBilling/CustomerBilling/GetBillingPriceArticles',
        );
    }

    GetBillingPrice(Id, ModuleId) {
        return this.fiBackend.fetchObject(
            'CustomerBilling/CustomerBilling/GetBillingPriceArticle/' + Id + '/' + ModuleId,
            CustomerBillingPriceArticleModel,
        );
    }

    SaveBillingPrice(price) {
        return this.fiBackend.fetchDataPost('CustomerBilling/CustomerBilling/SaveBillingPriceArticle', price);
    }

    DeleteBillingPrices(articleIds, articles) {
        return this.fiBackend.fetchDataPost(
            'CustomerBilling/CustomerBilling/DeleteBillingPriceArticles',
            articles.map(function (article) {
                return article.ArticleId;
            }),
        );
    }
}
